export default "__VITE_ASSET__CJTuGFgX__"